import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

import {
  NInputNumber,
  NInput,
  NInputGroup,
  NInputGroupLabel,
  NForm,
  NFormItem,
  useMessage,
} from 'naive-ui'
import BaseModule from './BaseModule.vue'
import MotorControls from '@/components/controls/common/MotorControls.vue'
import MotorError from '@/components/controls/common/MotorError.vue'

import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { usePositionStore } from '@/store/positionStore'
import { useDeviceStore } from '@/store/deviceStore'
import { useI18n } from 'vue-i18n'
import { deviceType } from '@/types/device'
import { MqttValue } from '@/mqttDefinitions'

import {
  saddleDefinitions,
  saddleCurrentPositionX,
  saddleCurrentPositionY,
  saddleCurrentSetPointX,
  saddleCurrentSetPointY,
} from '@/mqttDefinitions'


export default /*@__PURE__*/_defineComponent({
  __name: 'SaddleModule',
  setup(__props) {

const { t } = useI18n()
const positionStore = usePositionStore()
const deviceStore = useDeviceStore()
const message = useMessage()

const { submitPosition } = positionStore
const { absolutePosition, positionOffset, motorPosition, positionChange } =
  storeToRefs(positionStore)
const { isCalibrated, isLatestMeasurementCalibrated } =
  storeToRefs(positionStore)
const { motorStatus } = storeToRefs(deviceStore)

const updatePosition = (definition: MqttValue, newValue: number) => {
  if (!submitPosition(definition, newValue)) {
    message.error(t('setup.calibrate.outOfReach'))
  }
}

const currentPositionX = computed({
  get() {
    return absolutePosition.value.saddleX
  },
  set(newValue) {
    updatePosition(
      saddleCurrentSetPointX,
      newValue - positionOffset.value.saddleX,
    )
  },
})

const currentPositionY = computed({
  get() {
    return absolutePosition.value.saddleY
  },
  set(newValue) {
    updatePosition(
      saddleCurrentSetPointY,
      newValue - positionOffset.value.saddleY,
    )
  },
})

const hasSaddleMotorError = computed(() => {
  return (
    motorStatus.value.saddle.x.overcurrent ||
    motorStatus.value.saddle.y.overcurrent ||
    motorStatus.value.saddle.x.stalled ||
    motorStatus.value.saddle.y.stalled ||
    motorStatus.value.saddle.x.limitSwitch ||
    motorStatus.value.saddle.y.limitSwitch ||
    motorStatus.value.highTemperature ||
    motorStatus.value.hasHadHighTemperature
  )
})

const hasOtherBlockingMotorError = computed(() => {
  return (
    motorStatus.value.handleBar.x.overcurrent ||
    motorStatus.value.handleBar.y.overcurrent ||
    motorStatus.value.handleBar.x.stalled ||
    motorStatus.value.handleBar.y.stalled ||
    motorStatus.value.handleBar.x.limitSwitch ||
    motorStatus.value.handleBar.y.limitSwitch
  )
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModule, {
    definition: _unref(saddleDefinitions),
    "use-active": true,
    connected: true,
    error: 
      hasSaddleMotorError.value ||
      _unref(motorStatus).highTemperature ||
      _unref(motorStatus).hasHadHighTemperature
    ,
    inactive: hasOtherBlockingMotorError.value
  }, _createSlots({
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('modules.saddle.index')), 1)
    ]),
    _: 2
  }, [
    (!hasSaddleMotorError.value)
      ? {
          name: "left",
          fn: _withCtx(() => [
            _createVNode(MotorControls, {
              onClickUp: _cache[0] || (_cache[0] = ($event: any) => (
          updatePosition(_unref(saddleCurrentSetPointY), _unref(motorPosition).saddleY + 1)
        )),
              onClickDown: _cache[1] || (_cache[1] = ($event: any) => (
          updatePosition(_unref(saddleCurrentSetPointY), _unref(motorPosition).saddleY - 1)
        )),
              onClickLeft: _cache[2] || (_cache[2] = ($event: any) => (
          updatePosition(_unref(saddleCurrentSetPointX), _unref(motorPosition).saddleX + 1)
        )),
              onClickRight: _cache[3] || (_cache[3] = ($event: any) => (
          updatePosition(_unref(saddleCurrentSetPointX), _unref(motorPosition).saddleX - 1)
        )),
              onHoldUp: _cache[4] || (_cache[4] = ($event: any) => (
          updatePosition(_unref(saddleCurrentSetPointY), _unref(motorPosition).saddleY + 5)
        )),
              onHoldDown: _cache[5] || (_cache[5] = ($event: any) => (
          updatePosition(_unref(saddleCurrentSetPointY), _unref(motorPosition).saddleY - 5)
        )),
              onHoldLeft: _cache[6] || (_cache[6] = ($event: any) => (
          updatePosition(_unref(saddleCurrentSetPointX), _unref(motorPosition).saddleX + 5)
        )),
              onHoldRight: _cache[7] || (_cache[7] = ($event: any) => (
          updatePosition(_unref(saddleCurrentSetPointX), _unref(motorPosition).saddleX - 5)
        ))
            })
          ]),
          key: "0"
        }
      : undefined,
    (!hasSaddleMotorError.value)
      ? {
          name: "right",
          fn: _withCtx(() => [
            _createVNode(_unref(NForm), {
              ref: "formRef",
              "label-placement": "left"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NFormItem), { label: "X" }, {
                  default: _withCtx(() => [
                    (_unref(isCalibrated) && _unref(isLatestMeasurementCalibrated))
                      ? (_openBlock(), _createBlock(_unref(NInputGroup), { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NInputNumber), {
                              value: currentPositionX.value,
                              "show-button": false,
                              onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (currentPositionX.value = $event.target.value), ["enter"]))
                            }, null, 8, ["value"]),
                            (_unref(positionChange))
                              ? (_openBlock(), _createBlock(_unref(NInput), {
                                  key: 0,
                                  value: _unref(positionChange).saddleX,
                                  "show-button": false,
                                  disabled: "",
                                  class: "change-input"
                                }, null, 8, ["value"]))
                              : _createCommentVNode("", true),
                            _createVNode(_unref(NInputGroupLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(saddleCurrentPositionX).unit), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_unref(NInput), {
                          key: 1,
                          value: _unref(t)('common.notCalibrated'),
                          "show-button": false,
                          disabled: ""
                        }, null, 8, ["value"]))
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NFormItem), { label: "Y" }, {
                  default: _withCtx(() => [
                    (_unref(isCalibrated) && _unref(isLatestMeasurementCalibrated))
                      ? (_openBlock(), _createBlock(_unref(NInputGroup), { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NInputNumber), {
                              value: currentPositionY.value,
                              "show-button": false,
                              onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (currentPositionY.value = $event.target.value), ["enter"]))
                            }, null, 8, ["value"]),
                            (_unref(positionChange))
                              ? (_openBlock(), _createBlock(_unref(NInput), {
                                  key: 0,
                                  value: _unref(positionChange).saddleY,
                                  "show-button": false,
                                  disabled: "",
                                  class: "change-input"
                                }, null, 8, ["value"]))
                              : _createCommentVNode("", true),
                            _createVNode(_unref(NInputGroupLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(saddleCurrentPositionY).unit), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_unref(NInput), {
                          key: 1,
                          value: _unref(t)('common.notCalibrated'),
                          "show-button": false,
                          disabled: ""
                        }, null, 8, ["value"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512)
          ]),
          key: "1"
        }
      : undefined,
    (hasSaddleMotorError.value)
      ? {
          name: "middle",
          fn: _withCtx(() => [
            _createVNode(MotorError, {
              device: _unref(deviceType).saddle
            }, null, 8, ["device"])
          ]),
          key: "2"
        }
      : undefined
  ]), 1032, ["definition", "error", "inactive"]))
}
}

})